
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoLinkedinSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="#fff" d="M20.001 19.485v-7.77c0-2.64-2.145-4.77-4.77-4.77-1.38.045-2.64.75-3.405 1.905V7.23h-4.08v12.255h4.095V12.27c0-1.125.915-2.04 2.04-2.04s2.04.915 2.04 2.04v7.215h4.08zM2.975 4.935c1.365 0 2.46-1.11 2.46-2.475S4.325 0 2.96 0A2.465 2.465 0 00.5 2.475a2.452 2.452 0 002.46 2.46M5.03 7.23H.965v12.255H5.03V7.23z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoLinkedinSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
